module.exports = __webpack_public_path__ + "static/media/layout-about.ec417a8f.png";